import {
	SysToken,
	SsoService,
	request,
	KeycloakAPIs,
	requestrbac,
	coderequest,
	websiteRequest,
	uploadService,
} from "./request.js";
// code compiler
export function codecompileforeachcase(data) {
	return coderequest({
		url: `compile-test-case/`,
		method: "post",
		data,
	});
}

// reset password
export const resetPassword = (data) => {
	return KeycloakAPIs({
		url: `/reset-password/?email=${data.email}&password=${data.password}`,
		method: "put",
		data,
	});
};

// get profile details
export const getProfileDetails = (data) => {
	return KeycloakAPIs({
		url: `/verifyemail/?email=${data.email}`,
		method: "get",
		data,
	});
};

// get appilcations
export const getApplications = () => {
	return KeycloakAPIs({
		url: `/applications/`,
		method: "get",
	});
};
// sign Out alldevices
export const signOutAllDevices = () => {
	return KeycloakAPIs({
		url: `/signout/`,
		method: "delete",
	});
};
// sign out
export const signOutDevices = (data) => {
	return KeycloakAPIs({
		url: `/signout/?id=${data.id}`,
		method: "delete",
		data,
	});
};

// get profile info
export const getProfileInfo = (data) => {
	return KeycloakAPIs({
		url: "/update-user/",
		method: "put",
		data,
	});
};

// get device activity
export const getDeviceActivity = () => {
	return KeycloakAPIs({
		url: "/device-activity/",
		method: "get",
	});
};
// Get Generate Share Link
export const getCodingLanguages = () => {
	return request({
		url: `lis/code-languages/`,
		method: "get",
	});
};
// /compiler-with-single-testcase/
export const getcodesnippetcompilertestCase = (data) => {
	return coderequest({
		url: "compiler-with-single-testcase/",
		method: "post",
		data,
	});
};
// /compiler/
export const getcodesnippetcompiler = (data) => {
	return coderequest({
		url: "compiler/",
		method: "post",
		data,
	});
};
export const testCaseRunner = (data) => {
	return coderequest({
		url: "compiler-with-testcase/",
		method: "post",
		data,
	});
};

export const getcodesnippet = (data) => {
	return coderequest({
		url: "code-gen/",
		method: "post",
		data,
	});
};
// AccessPanel APi Post

export const postAccessData = (data) => {
	return requestrbac({
		url: "userToProject/",
		method: "post",
		data,
	});
};

// AccessPanel Roles APi GET
export const getAccessRoles = (data) => {
	return requestrbac({
		url: `roles/?project=assessment&role=${data.role}&licenseKey=L092921A001`,
		method: "get",
	});
};

// AccessPanel APi GET
export const getAccessData = (data) => {
	return requestrbac({
		url: `userToProject/`,
		method: "get",
		params: {
			project: "assessment",
			licenseKey: data.licensekey,
			value: data.user,
			searchQuery: data.searchQuery,
		},
	});
};

// AccessPanel User Put Api
export const putAccessData = (data) => {
	return requestrbac({
		url: "userToProject/?project=assessment",
		method: "put",
		data,
	});
};

// AccessPanel Delete
export const deleteAccessData = (data) => {
	return requestrbac({
		url: `userToProject/?project=assessment`,
		method: "delete",
		data,
	});
};

// AccessPanel Roles APi GET
export const getRolesDetails = (data) => {
	return requestrbac({
		url: `roles/`,
		method: "get",
		params: {
			licenseKey: data.licenseKey,
			type: "ALLROLES",
			project: "assessment",
			searchQuery: data.searchQuery,
		},
	});
};

// Post Roles APi
export const postRoles = (data) => {
	return requestrbac({
		url: `roles/?project=assessment`,
		method: "post",
		data,
	});
};

// Edit Roles APi
export const putRoles = (data) => {
	return requestrbac({
		url: `roles/`,
		method: "put",
		data,
	});
};

// Delete Roles APi
export const deleteRoles = (data) => {
	return requestrbac({
		url: `roles/`,
		method: "delete",
		data,
	});
};

export const userToLicenseData = (data) => {
	return request({
		url: `lis/userToLicense/`,
		method: "post",
		data,
	});
};

// For Databank get question
export const moveDataBankQuesData = (data) => {
	return request({
		url: `lis/v2/MoveQuestion/`,
		method: "post",
		data,
	});
};

// For deleting Test question only
export const deleteTestQuesData = (data) => {
	return request({
		url: `lis/v2/MoveQuestion/`,
		method: "delete",
		data,
	});
};

export const getDataBankQuesData = (data) => {
	const config = {
		url: `questionAggr/?QuesType=${data.type}&page=${data.page}&count=${data.count}&testID=${data.testID}&sectionID=${data.sectionID}&diffLevel=${data.diffLevel}`,
		method: "get",
	};
	if (data.marks) {
		config["params"] = {
			marks: data.marks,
		};
	}
	if (data.questionTags) {
		config["params"] = {
			questionTag: data.questionTags.toString(),
		};
	}
	return request(config);
};
export const getDataBank = (data) => {
	return request({
		url: "v3/data-bank/",
		method: "post",
		data,
	});
};
// Get LicenseKey
export const getUserData = (data) => {
	return request({
		url: `lis/LicenseGen/`,
		method: "get",
		data,
	});
};

export const postUserData = (data) => {
	return request({
		url: `lis/LicenseGen/`,
		method: "post",
		data,
	});
};

// Get AUTO GENERATED QUESTIONS
export const getAutoGeneratedQus = (data) => {
	return request({
		url: `auto/auto-gen/`,
		method: "get",
		params: {
			topicID: data.topicID,
			searchQuery: data.searchQuery,
			sortBy: data.sortBy,
			order: data.order,
			sections: data.sections,
			candidates: data.candidates,
			publicAvailability: data.publicAvailability,
			type: data.type,
		},
	});
};

export const AutogenDatabankTable = (data) => {
	return request({
		url: `auto/autogenDatabankTable/`,
		method: "post",
		data,
	});
};
// -----------------------
// ------- TOPIC ---------
// -----------------------
// POST Topic
export const postTopic = (data) => {
	return request({
		url: `lis/TopicOrg/`,
		method: "post",
		data,
	});
};

// PUT Topic
export const putTopic = (data) => {
	return request({
		url: `lis/TopicOrg/`,
		method: "put",
		data,
	});
};

// DELETE Topic
export const deleteTopic = (data) => {
	return request({
		url: `lis/TopicOrg/`,
		method: "delete",
		data,
	});
};

// GET Topic
export const getTopic = (data) => {
	const config = {
		url: `lis/TopicOrg/`,
		method: "get",
		params: {
			searchQuery: data.searchQuery,
			sortBy: data.sortBy,
			order: data.order,
			testCount: data.testCount,
			publicAvailability: data.publicAvailability,
			type: data.type,
		},
	};

	return request(config);
};

// ------------------------
// -------- TEST ----------
// ------------------------
// POST Test
export const postTest = (data) => {
	return request({
		url: `lis/TestOrg/`,
		method: "post",
		data,
	});
};

// PUT Test
export const putTest = (data) => {
	return request({
		url: `lis/TestOrg/`,
		method: "put",
		data,
	});
};

// DELETE Test
export const deleteTest = (data) => {
	return request({
		url: `lis/TestOrg/`,
		method: "delete",
		data,
	});
};

// GET Test
export const getTest = (topicID, testID) => {
	const config = {
		url: `lis/TestOrg/?topicID=${topicID}`,
		method: "get",
	};
	if (testID) {
		config["params"] = {
			testID: testID,
		};
	}
	return request(config);
};

// GET Categories
export const getCategories = () => {
	return request({
		url: `lis/categories/`,
		method: "get",
	});
};

// GET Sub Categories
export const getSubCategories = () => {
	return request({
		url: `lis/sub-categories/`,
		method: "get",
	});
};

// get archived test
export const getArchivedTest = (data) => {
	return request({
		url: `lis/test-list/`,
		method: "post",
		data,
	});
};

// post selcted tests to topic
export const postArchivedTest = (data) => {
	return request({
		url: `lis/clone-tests/`,
		method: "post",
		data,
	});
};

// ---------------------------
// -------- SECTION ----------
// ---------------------------
// POST Test
export const postSection = (data) => {
	return request({
		url: `lis/SectionOrg/`,
		method: "post",
		data,
	});
};

// PUT Test
export const putSection = (data) => {
	return request({
		url: `lis/SectionOrg/`,
		method: "put",
		data,
	});
};

// DELETE Test
export const deleteSection = (data) => {
	return request({
		url: `lis/SectionOrg/`,
		method: "delete",
		data,
	});
};

// GET Test
export const getSection = (data) => {
	return request({
		url: `lis/SectionOrg/` + `?testID=` + data,
		method: "get",
	});
};

// ------------------------
// -------- SHARE PAGE ----------
// ------------------------
// POST Test
export const postSharePageData = (data) => {
	return request({
		url: `lis/ShareOrg/`,
		method: "post",
		data,
	});
};

// PUT Test
export const putSharePageData = (data) => {
	return request({
		url: `../`,
		method: "put",
		data,
	});
};

// DELETE Test
export const deleteSharePageData = (data) => {
	return request({
		url: `../`,
		method: "delete",
		data,
	});
};

// GET Test
export const getSharePageData = (data) => {
	return request({
		url: `lis/ShareOrg/` + `?testID=` + data,
		method: "get",
	});
};

//TOGGLE PREVIOUS LINK STATUS
export const setPrevLink = (data) => {
	return request({
		url: `share/v2/ShareOrg/`,
		method: "put",
		data,
	});
};

// GET ALL Questions
export const getQuestions = (data) => {
	return request({
		url:
			`getQuestions/` +
			`?testID=` +
			data.testID +
			`&sectionID=` +
			data.sectionID,
		method: "get",
	});
};

export const putMCQquestion = (data) => {
	return request({
		url: `mcqQuestions/`,
		method: "put",
		data,
	});
};
export const postMCQquestion = (data) => {
	return request({
		url: `mcqQuestions/`,
		method: "post",
		data,
	});
};
export const deleteMCQquestion = (data) => {
	return request({
		url: `v2/mcqQuestions/`,
		method: "delete",
		data,
	});
};
export const getMCQquestion = () => {
	return request({
		url: `mcqQuestions/`,
		method: "get",
	});
};
// v2 mcq questions fro question bank start
export const putMCQquestionv2 = (data) => {
	return request({
		url: `v2/mcqQuestions/`,
		method: "put",
		data,
	});
};
export const postMCQquestionv2 = (data) => {
	return request({
		url: `v2/mcqQuestions/`,
		method: "post",
		data,
	});
};
// v2 mcq questions fro question bank end

// v2 common questions fro question bank start

export const putCommonQuestionv2 = (data) => {
	return request({
		url: `v2/commonQuestions/`,
		method: "put",
		data,
	});
};
export const postCommonQuestionv2 = (data) => {
	return request({
		url: `v2/commonQuestions/`,
		method: "post",
		data,
	});
};
// v2 common questions fro question bank end

export const putCommonQuestion = (data) => {
	return request({
		url: `commonQuestions/`,
		method: "put",
		data,
	});
};
export const postCommonQuestion = (data) => {
	return request({
		url: `commonQuestions/`,
		method: "post",
		data,
	});
};
export const getCommonQuestion = () => {
	return request({
		url: `commonQuestions/`,
		method: "get",
	});
};
export const deleteCommonQuestionv2 = (data) => {
	return request({
		url: `v2/commonQuestions/`,
		method: "delete",
		data,
	});
};
// Fill in the blanks
export const putFillInTheBlanksquestion = (data) => {
	return request({
		url: `fillInTheBlanksQuestions/`,
		method: "put",
		data,
	});
};
export const postFillInTheBlanksquestion = (data) => {
	return request({
		url: `fillInTheBlanksQuestions/`,
		method: "post",
		data,
	});
};
export const deleteFillInTheBlanksquestion = (data) => {
	return request({
		url: `fillInTheBlanksQuestions/`,
		method: "delete",
		data,
	});
};
export const getFillInTheBlanksquestion = () => {
	return request({
		url: `fillInTheBlanksQuestions/`,
		method: "get",
	});
};

// v2 match questions fro question bank start
export const postMatchTheFollowingQuestionv2 = (data) => {
	return request({
		url: `v2/matchTheFollowingQuestions/`,
		method: "post",
		data,
	});
};
export const putMatchTheFollowingQuestionv2 = (data) => {
	return request({
		url: `v2/matchTheFollowingQuestions/`,
		method: "put",
		data,
	});
};
// v2 match questions fro question bank start

export const postMatchTheFollowingQuestion = (data) => {
	return request({
		url: `matchTheFollowingQuestions/`,
		method: "post",
		data,
	});
};
export const putMatchTheFollowingQuestion = (data) => {
	return request({
		url: `matchTheFollowingQuestions/`,
		method: "put",
		data,
	});
};
export const getMatchTheFollowingQuestion = () => {
	return request({
		url: `matchTheFollowingQuestions/`,
		method: "get",
	});
};
export const deleteMatchTheFollowingQuestion = (data) => {
	return request({
		url: `v2/matchTheFollowingQuestions/`,
		method: "delete",
		data,
	});
};
// Post Generate Share Link

export const postShareLink = (data) => {
	return request({
		url: `lis/LinkGen/`,
		method: "post",
		data,
	});
};

// Get Generate Share Link
export const getShareLink = (data) => {
	return request({
		url: `lis/LinkGen/`,
		method: "get",
		data,
	});
};
//Question bank
export const getquestionbank = (data) => {
	const config = {
		url: `v2/questionAggr?QuesType=${data.type}&createdAt=${data.order}&diffLevel=${data.diff}&page=${data.page}&count=${data.numofrecords}`,
		method: "get",
	};
	if (data.marks) {
		config["params"] = {
			marks: data.marks,
		};
	}
	if (data.search) {
		config["params"] = {
			searchQuery: data.search,
		};
	}
	if (data.questionTags) {
		config["params"] = {
			questionTag: data.questionTags.toString(),
		};
	}

	return request(config);
};

// delete multiple questions
export const deleteMultipleQuestion = (data) => {
	return request({
		url: `v2/deletemultiplequestions`,
		method: "delete",
		data,
	});
};

// delete multiple questions force
export const forcedeletemultiplequestions = (data) => {
	return request({
		url: `v3/forcedeletemultiplequestions/`,
		method: "delete",
		data,
	});
};

export const postAutoGenerate = (data) => {
	return request({
		url: `auto/auto-gen/`,
		method: "post",
		data,
	});
};
export const getAutoGenerate = (data) => {
	return request({
		url: `auto/auto-gen/?testID=${data}`,
		method: "get",
	});
};
export const putAutoGenerate = (data) => {
	return request({
		url: `auto/auto-gen/`,
		method: "put",
		data,
	});
};
export const delAutoGenerate = (data) => {
	return request({
		url: `auto/auto-gen`,
		method: "delete",
		data,
	});
};

// -------- Get Excel Template ----------
export const getExcelTemplate = () => {
	return request({
		url: `importExcel/`,
		method: "get",
	});
};
// -------- Post Excel Template ----------
export const postExcel = (data) => {
	return request({
		url: `v3/importExcel/`,
		method: "post",
		data,
	});
};
export const postGroupExcel = (data) => {
	return request({
		url: `/share/import-emails/`,
		method: "post",
		data,
	});
};
export const getGroupTemplate = (data) => {
	return request({
		url: `/share/import-emails/`,
		method: "get",
		data,
	});
};

// ---------------------------
// -------- REPORTS ----------
// ---------------------------

// -------- LICENSE LEVEL REPORTS ----------
export const getLicenseStats = () => {
	return request({
		url: "rep/licenseStats/",
		method: "get",
	});
};

export const getOverallActiveStudents = () => {
	return request({
		url: "rep/activeCandidatesInLicense/",
		method: "get",
	});
};

// -------- TOPIC LEVEL REPORTS ----------
/**
 * Return a promise to get active students in a specific topic
 * @param {string} topicId
 * @returns Promise
 */
export const getTopicActiveStudents = (topicId) => {
	return request({
		url: "rep/activeCandidatesInTopic/",
		method: "get",
		params: {
			topicID: topicId,
		},
	});
};
// -------- TEST LEVEL REPORTS ----------
/**
 * Return a promise to get test statistics for a specific test
 * @param {string} testId
 * @returns Promise
 */
export const getTestStats = (testId) => {
	return request({
		url: "rep/testStats/",
		method: "get",
		params: {
			testID: testId,
		},
	});
};

/**
 * Return a promise to get class interval and frequency of scoring in a specific test
 * @param {string} topicId
 * @returns Promise
 */
export const getMarksDistribution = (testId) => {
	return request({
		url: "rep/markIntervalGraph",
		method: "get",
		params: {
			testID: testId,
		},
	});
};

// -------- CANDIDATE LEVEL REPORTS ----------
/**
 * Return a promise to get class interval and frequency of scoring in a specific test
 * @param {string} topicId
 * @returns Promise
 */
export const getCandidateScoreDetails = (testId, candidateId) => {
	const config = {
		url: "rep/candidateScore/",
		method: "get",
		params: {
			testID: testId,
		},
	};
	if (candidateId) {
		config.params["candidateID"] = candidateId;
	}
	return request(config);
};
/**
 * Return a promise to get competency data for sections and difficulty for a test and candidate
 * @param {string} subject ("section" | "difficulty")
 * @param {string} testId
 * @param {string} candidateId
 * @returns Promise
 */
export const getCompetency = (subject, testId, candidateId) => {
	return request({
		url: `rep/${subject}Competency/`,
		method: "get",
		params: {
			testID: testId,
			candidateID: candidateId,
		},
	});
};

// -------- SHARED APIS ----------
/**
 * Returns a promise tp get all topic information or specific information when ID is provided
 * @param {string} subject ("section" | "difficulty")
 * @param {string} testId
 * @param {string} candidateId
 * @returns Promise
 */
export const getTopicInformation = (topicId = null) => {
	const config = {
		url: "rep/topicInformation/",
		method: "get",
	};
	if (topicId) {
		config["params"] = {
			topicID: topicId,
		};
	}
	return request(config);
};

/**
 * Gets all test information or specific test information when testID is provided
 * @param {string} topicId
 * @param {string} testId
 * @returns Promise
 */
export const getTestInformation = (topicId, testId = null) => {
	const config = {
		url: "rep/testInformation/",
		method: "get",
		params: {
			topicID: topicId,
		},
	};
	if (testId) {
		config.params["testID"] = testId;
	}
	return request(config);
};

/**
 * Gets trend data for both a (tests belonging to a specific topic  | topics in general )
 * @param {string} subject ("topic" | "test")
 * @param {string} topicId
 * @returns Promise
 */
export const getTrendBarData = (subject, topicId = null) => {
	const config = {
		url: `rep/${subject}Trend/`,
		method: "get",
	};
	if (topicId) {
		config["params"] = {
			topicID: topicId,
		};
	}
	return request(config);
};

/**
 * Gets Pie chart data for both section composition and difficulty composition
 * @param {string} subject ("section" | "difficulty")
 * @param {string} testId
 * @param {string} filter
 * @returns Promise
 */
export const getPieData = (subject, testId, filter = null) => {
	const config = {
		url: `rep/${subject}Composition/`,
		method: "get",
		params: { testID: testId },
	};
	if (filter) {
		config.params.filter = filter;
	}
	return request(config);
};

/**
 * Returns a promise to get all time series data for usage for different subject and timelines
 * @param {string} subject ("testsTaken" | "topicsCreated" | "testsCreated")
 * @param {string} topicId
 * @param {string} timeline ("all" | "year" | "month" | "week" )
 * @returns Promise
 */
export const getUsageLineData = (subject, timeline, topicId = null) => {
	const config = {
		url: `rep/${subject}OverTime/`,
		method: "get",
		params: {
			timeline,
		},
	};
	if (topicId) {
		config.params["topicID"] = topicId;
	}
	return request(config);
};

export const getStatisticReport = (data) => {
	return request({
		url: "rep/v4/license-info/",
		method: "get",
		params: {
			statsType: data,
		},
	});
};

export function getOverallReports(data) {
	const config = {
		url: "rep/v4/info-overview/",
		method: "get",
		params: {
			timeline: data,
		},
	};
	return request(config);
}

export const downloadExcel = (testID) => {
	return request({
		url: `rep/downloadExcel/?testID=${testID}`,
		method: "get",
	});
};

// Proctoring Api
export const getProctorGroups = (data) => {
	return request({
		url: "proctoring/v2/group-list/",
		method: "post",
		data,
	});
};
// Dashboard Proctoring Get All Test
export const getProcteringAllTests = (data) => {
	return request({
		url: "proctoring/v2/testList/",
		method: "post",
		data,
	});
};
export const getProcteringFilter = (data) => {
	return request({
		url: `proctoring/v2/proc-filters/`,
		method: "get",
		params: {
			topicID: data.topicID,
			filterType: data.filterType,
			count: "30",
			page: data.page,
			searchQuery: data.searchQuery,
			groupID: data.groupID,
		},
	});
};

export const candidatesInTest = (testID) => {
	return request({
		url: `rep/candidatesInTest/?testID=${testID}`,
		method: "get",
	});
};

export const getproctoringCandidatesv3 = (data) => {
	return request({
		url: `proctoring/v3/proctoring-candidates-v2/?testID=${data.testID}&groupID=${data.groupID}&candidateID=${data.candidateID}&topicID=${data.topicID}&attemptNo=${data.attemptNo}`,
		method: "get",
	});
};
export const getproctoringCandidates = (data) => {
	return request({
		url: `proctoring/v2/proctoringCandidates/?testID=${data.testID}&groupID=${data.groupID}&candidateID=${data.candidateID}&topicID=${data.topicID}`,
		method: "get",
	});
};

export const getProctoringData = (data) => {
	return request({
		url: `proctoring/v3/video-proctoring-analysis/?testID=${data.testID}&groupID=${data.groupID}&candidateID=${data.candidateID}&topicID=${data.topicID}&attemptNo=${data.attemptNo}`,
		method: "get",
	});
};
export const getProctorGroupsForLineGraph = (data) => {
	return request({
		url: `proctoring/v2/proctoring-line-chart/?timeline=${data} `,
		method: "get",
	});
};
export const getCapturedcandidateimage = (
	topicID,
	testID,
	groupID,
	candidateID,
	attemptNo
) => {
	return request({
		url: `can/capturecandidateimage/?topicID=${topicID}&testID=${testID}&candidateID=${candidateID}&attemptNo=${attemptNo}&groupId=${groupID}`,
		method: "get",
	});
};

// Proctoring Video Api

//  Proctoring Video Api
export const getCandidateVideoLinks = (testID, candidateID, attemptNo) => {
	return request({
		url: `proctoring/getVideo/?testID=${testID}&candidateID=${candidateID}&attemptNo=${attemptNo}`,
		method: "get",
	});
};

export const getCandidateActivityLog = (testID, topicID, userID, attemptNo) => {
	return request({
		url: `proctoring/getActivityLog/?testID=${testID}&topicID=${topicID}&userID=${userID}&attemptNo=${attemptNo}`,
		method: "get",
	});
};

export const getCandidateGetActivityLogCount = (
	testID,
	topicID,
	userID,
	attemptNo
) => {
	return request({
		url: `proctoring/getActivityLogCount/?testID=${testID}&topicID=${topicID}&userID=${userID}&attemptNo=${attemptNo}`,
		method: "get",
	});
};

//KeyCloakAPIs
export const getSysToken = () => {
	return SysToken({
		url: `getSysToken`,
		method: "get",
	});
};

//KeyCloakAPIs
export const forgotPassword = (email) => {
	return SysToken({
		url: `forgot-password/?email=${email}`,
		method: "get",
	});
};

export const dosanddontslist = () => {
	return request({
		url: `proctoring/codeList`,
		method: "get",
	});
};

export const getAllQuestionTags = () => {
	return request({
		url: `questionTags`,
		method: "get",
	});
};

export const getShareGroup = (data) => {
	const config = {
		url: `share/v2/group/?tag=${data.tag}&testID=${data.testID}`,
		method: "get",
	};
	if (data.configID) {
		config["params"] = {
			configID: data.configID,
		};
	}
	return request(config);
};
export const gettaggedtestsdetails = (data) => {
	return request({
		url: `share/v2/taggedTestsDetails/?groupID=${data.groupID}`,
		method: "get",
		data,
	});
};
export const taggedGroup = (data) => {
	const config = {
		url: `share/taggedgroup/?tag=${data.tag}&testID=${data.testID}`,
		method: "get",
	};
	if (data.groupType) {
		config["params"] = {
			groupType: data.groupType,
		};
	}
	return request(config);
};
export const postTaggedGroup = (data) => {
	return request({
		url: `share/v3/tagged-group/`,
		method: "post",
		data,
	});
};
export const shareLink = (data) => {
	return request({
		url: `share/v2/ShareOrg/`,
		method: "post",
		data,
	});
};

export const testSharedCheck = (data) => {
	return request({
		url: `share/v2/testSharedCheck/?testID=${data}`,
		method: "get",
	});
};
export const getAllGroups = (data) => {
	return request({
		url: `share/v2/get-all-groups/`,
		method: "post",
		data,
	});
};
export const postShareGroup = (data) => {
	return request({
		url: `share/v2/group/`,
		method: "post",
		data,
	});
};
export const putShareGroup = (data) => {
	return request({
		url: `share/v2/group/`,
		method: "put",
		data,
	});
};
export const deleteShareGroup = (data) => {
	return request({
		url: `share/v2/group/`,
		method: "delete",
		data,
	});
};
export const generateLink = (data) => {
	return request({
		url: `share/v2/LinkGen/`,
		method: "post",
		data,
	});
};
export const addConfig = (data) => {
	return request({
		url: `share/v2/config/`,
		method: "post",
		data,
	});
};
export const editConfig = (data) => {
	return request({
		url: `share/v2/config/`,
		method: "put",
		data,
	});
};
export const getConfig = (configID) => {
	const config = {
		url: `share/config/`,
		method: "get",
	};
	if (configID) {
		config["params"] = {
			configID: configID,
		};
	}

	return request(config);
};
export const getParticularConfig = (configID, testID, topicID) => {
	const config = {
		url: `share/config/?configID=${configID}/?testID=${testID}/?topicID=${topicID}`,
		method: "get",
	};

	return request(config);
};

export const postTaggedConfig = (data) => {
	return request({
		url: `share/v2/tagged-config/`,
		method: "post",
		data,
	});
};

export const deleteConfig = (data) => {
	return request({
		url: `share/v2/config/?configID=${data}`,
		method: "delete",
		data,
	});
};
// SSO API

export const userLogin = (data) => {
	return SsoService({
		url: `auth/realms/SimplifyCV/protocol/openid-connect/token`,
		method: "post",
		data,
	});
};

export const userLogOut = (data, headers) => {
	return SsoService({
		url: `auth/realms/SimplifyCV/protocol/openid-connect/logout`,
		method: "post",
		headers: headers,
		data,
	});
};
// evaluator crud
export const addevaluator = (data) => {
	return request({
		url: `share/v2/evaluator`,
		method: "post",
		data,
	});
};
export const tagEvaluator = (data) => {
	return request({
		url: `share/v2/tagEvaluator/`,
		method: "put",
		data,
	});
};
export const getEvaluatorAdmin = (data) => {
	return request({
		url: `share/v2/evaluator-admin/`,
		method: "post",
		data,
	});
};
export const getEvalList = (evaluatorID) => {
	const config = {
		url: `share/evaluator`,
		method: "get",
	};
	if (evaluatorID) {
		config["params"] = {
			evaluatorID: evaluatorID,
		};
	}
	return request(config);
};
export const deleteEval = (data) => {
	return request({
		url: `share/v2/evaluator/?evaluatorID=${data}`,
		method: "delete",
		data,
	});
};
export const updateEval = (data) => {
	return request({
		url: `share/v2/evaluator`,
		method: "put",
		data,
	});
};
// eval crud end
// eval proctoring apis
export const EvaluatorTest = () => {
	return request({
		url: `proctoring/evaluatortests`,
		method: "get",
	});
};
export const EvaluatorGroups = (testID) => {
	return request({
		url: `proctoring/evaluatorgroups/?testID=${testID}`,
		method: "get",
	});
};

export const EvaluatorCandidates = (testID, groupID, candidateID) => {
	const config = {
		url: `proctoring/evaluatorcandidates/?testID=${testID}&groupID=${groupID}`,
		method: "get",
	};
	if (candidateID) {
		config["params"] = {
			candidateID: candidateID,
		};
	}
	return request(config);
};
// getting test answers fr a candidate
export const getCandidateTestTiming = (
	topicID,
	testID,
	groupID,
	candidateID,
	emailID,
	attemptNo
) => {
	return request({
		url:
			`can/candidateTestResponse/?topicID=` +
			topicID +
			`&testID=` +
			testID +
			`&groupID=` +
			groupID +
			`&candidateID=` +
			candidateID +
			`&evaluation=` +
			emailID +
			`&attemptNo=` +
			attemptNo,
		method: "get",
	});
};
// evaluating answer post api
export const evaluateAnswers = (data) => {
	return request({
		url: `can/v2/marking/`,
		method: "post",
		data,
	});
};
// evaluateor tagged test pagination
export const postProctorTopic = (data) => {
	return request({
		url: `proctoring/v2/topic-list/`,
		method: "post",
		data,
		// params: {
		//   sortBy: data.sortBy,
		//   order: data.order,
		//   type: data.type,
		//   searchQuery: data.searchQuery,

		// },
	});
};
export const postTaggedEvalTest = (data) => {
	return request({
		url: `proctoring/v2/evaluator-tests/`,
		method: "post",
		data,
	});
};
// evaluator tagged topics
export function postTaggedEvalTopic(data) {
	return request({
		url: `proctoring/v2/evaluator-topic/`,
		method: "post",
		data,
		// params: {
		//   sortBy: data.sortBy,
		//   order: data.order,
		//   type: data.type,
		//   searchQuery: data.searchQuery,
		// },
	});
}

// evaluator groups pagination
export const postEvalTestGroups = (data) => {
	return request({
		url: `proctoring/v2/evaluator-groups/`,
		method: "post",
		data,
	});
};

//get  evaluator candidates
export const getEvalTestCandidates = (data) => {
	return request({
		url: `proctoring/v2/evaluatorcandidates/`,
		method: "post",
		data,
	});
};

export const checkAutocorrect = (data) => {
	return request({
		url: `v2/testAutoCorrectCheck/?testID=${data}`,
		method: "get",
	});
};

//export excel
export const getExcelReport = (data) => {
	return request({
		url: `/rep/assessment/result_with_proctor/excel/`,
		method: "get",
		params: data,
		responseType: "blob",
	});
};

export const scatterGraph2Api = (data) => {
	return request({
		url: `rep/v4/groups-info/?timeline=${data}`,
		method: "get",
	});
};

//Api for New Group Date Table -
export function groupDataTable(data) {
	const config = {
		url: `rep/v4/groups-table`,
		method: "get",
		params: {
			searchQuery: data.searchQuery,
			timeline: data.timeline,
			sortBy: data.sortBy,
			order: data.order,
			page: data.page,
			count: data.count,
		},
	};
	return request(config);
}

export const scatterGraph1Api = (data) => {
	return request({
		url: `rep/v4/topics-info/`,
		method: "get",
		data,
	});
};

export function scatterGraph1ApiAll(data) {
	const config = {
		url: `rep/v4/topics-info/`,
		method: "get",
		params: {
			timeline: data.timeline,
			startDate: data.startDate,
			endDate: data.endDate,
		},
	};
	return request(config);
}

export const barApi = (data) => {
	return request({
		url: `rep/v4/tests-over-time/?timeline=${data}`,
		method: "get",
	});
};

export const barCandidate = (data) => {
	return request({
		url: `rep/v4/candidates-over-time/?timeline=${data}`,
		method: "get",
	});
};

export const pieApi = (data) => {
	return request({
		url: `/rep/v4/test-overall-progress/?timeline=daily`,
		method: "get",
		data,
	});
};

//Only to get filter tags of tree graph(Dendogram)
export function treeGraphFilters(data) {
	const config = {
		url: `rep/v4/tag-distribution/`,
		method: "get",
		params: {
			timeline: data.timeline,
			startDate: data.startDate,
			endDate: data.endDate,
			filtertags: data.filtertags,
		},
	};
	return request(config);
}

//On Timeline changes
export function treeGraphApi(data) {
	const config = {
		url: `rep/v4/tag-distribution/`,
		method: "get",
		params: {
			timeline: data.timeline,
			tag: data.tag,
			startDate: data.startDate,
			endDate: data.endDate,
		},
	};

	return request(config);
}

export function getDataBasedOnLazyLoadingInHomePage(data) {
	const config = {
		url: `lis/TopicOrg/`,
		method: "get",
		params: {
			searchQuery: data.searchQuery,
			sortBy: data.sortBy,
			order: data.order,
			testCount: data.testCount,
			publicAvailability: data.publicAvailability,
			type: data.type,
			page: data.page,
			count: data.count,
		},
	};

	return request(config);
}

export const getTestOrgPagination = (data) => {
	const config = {
		url: `lis/get-test-org/`,
		method: "get",
		params: {
			topicID: data.topicID,
			searchQuery: data.searchQuery,
			sortBy: data.sortBy,
			order: data.order,
			sections: data.sections,
			candidates: data.candidates,
			publicAvailability: data.publicAvailability,
			type: data.type,
			page: data.page,
			count: data.count,
		},
	};

	return request(config);
};

export const getAutoGeneratedQusPagintion = (data) => {
	return request({
		url: `auto/auto-gen/`,
		method: "get",
		params: {
			topicID: data.topicID,
			searchQuery: data.searchQuery,
			sortBy: data.sortBy,
			order: data.order,
			sections: data.sections,
			candidates: data.candidates,
			publicAvailability: data.publicAvailability,
			type: data.type,
			page: data.page,
			count: data.count,
		},
	});
};
//Get expertise for panelist
export const getsearchresexp = (data) => {
	return request({
		url: `location/expertise/?expertise=${data}`,
		method: "get",
	});
};
//Get skills for panelist
export const getsearchresskl = (data) => {
	return request({
		url: `location/skill/?skill=${data}`,
		method: "get",
	});
};
export const getsearchresloc = (data) => {
	return request({
		url: `location/location/?location=${data}`,
		method: "get",
	});
};

//Post expertise for panelist
export const addsearchresexp = (data) => {
	return request({
		url: `location/expertise`,
		method: "post",
		data,
	});
};
//Post skills for panelist
export const addsearchresskl = async (data) => {
	return request({
		url: `location/skill`,
		method: "post",
		data,
	});
};
export const addcodingquestion = async (data) => {
	return request({
		url: `code/code/add-coding-question`,
		method: "post",
		data,
	});
};
export const getcodingquestion = async (data) => {
	return request({
		url: `code/code/add-coding-question?questionKey=${data}`,
		method: "get",
	});
};
export const getcodingquestions = async (data) => {
	return request({
		url: `code/code/get-coding-question/`,
		method: "post",
		data,
	});
};

export const deletecodingquestions = async (data) => {
	return request({
		url: `v2/codingQuestion/`,
		method: "delete",
		data,
	});
};
export const updatecodingquestion = async (data) => {
	return request({
		url: `code/code/add-coding-question`,
		method: "put",
		data,
	});
};
export const gettestcasetemplate = async (data) => {
	return request({
		url: `code/code/excel-import-testcases/`,
		method: "get",
		data,
	});
};
export const uploadExcel = (data) => {
	return request({
		url: `code/code/excel-import-testcases/`,
		method: "post",
		data,
	});
};
export const deletecodingquestion = async (data) => {
	return request({
		url: `code/code/add-coding-question`,
		method: "delete",
		data,
	});
};
export const getquestiontagsct = async (data) => {
	return request({
		url: `code/code/code-question-tags/`,
		method: "post",
		data,
	});
};
export const getPreference = () => {
	return websiteRequest({
		url: `user-preference/`,
		method: "get",
	});
};

export const postPreference = (data) => {
	return websiteRequest({
		url: `user-preference/`,
		method: "post",
		data,
	});
};

export const createPrject = async (data) => {
	return request({
		url: `/sandbox/projects/`,
		method: "post",
		data,
	});
};

export const getCheckingMetrics = async (templateID) => {
	return request({
		url: `sandbox/checking-metrics/${templateID}/`,
		method: "get",
	});
};

export const getTemplateReadme = async (templateID) => {
	return request({
		url: `sandbox/template-readme/${templateID}/`,
		method: "get",
	});
};

export const getSandBoxTemplate = async () => {
	return request({
		url: `sandbox/template`,
		method: "get",
	});
};

export const getIde = async (data) => {
	return request({
		url: `sandbox/ide/?templateID=${data}`,
		method: "get",
	});
};

export const extendIde = async (sandboxID) => {
	return request({
		url: `sandbox/ide/`,
		method: "put",
		params: {
			sandboxID,
		},
	});
};

export function pollSandboxDetails(sandboxJobID) {
	return request({
		url: `sandbox/ide/status/${sandboxJobID}/`,
		method: "get",
	});
}

export const saveIde = async (data) => {
	return request({
		url: `sandbox/ide/`,
		method: "post",
		data,
	});
};

export const removeIde = async (data) => {
	return request({
		url: `sandbox/ide/?templateID=${data}`,
		method: "delete",
	});
};

export const getAllProjects = async (filters) => {
	return request({
		url: `sandbox/projects/`,
		method: "get",
		params: filters,
	});
};

export const getProject = async (id, checkingMetricsMapper = false) => {
	return request({
		url: `sandbox/projects/${id}`,
		method: "get",
		params: {
			checkingMetricsMapper,
		},
	});
};

export const editProject = async (id, data) => {
	return request({
		url: `sandbox/projects/${id}/`,
		method: "put",
		data,
	});
};

export const deleteProject = async (id) => {
	return request({
		url: `sandbox/projects/${id}`,
		method: "delete",
	});
};

export const cloneProject = async (id, data) => {
	return request({
		url: `sandbox/projects/clone/${id}/`,
		method: "post",
		data,
	});
};

export const adminConsole = async (data) => {
	return request({
		url: `sandbox/admin-console/`,
		method: "post",
		data,
	});
};

export const viewIde = async (id, params) => {
	return request({
		url: `sandbox/candidate/ide/${id}/`,
		method: "get",
		params: params,
	});
};

export const extendCandidateIde = async (id, sandboxID) => {
	return request({
		url: `sandbox/candidate/ide/${id}/`,
		method: "put",
		params: {
			sandboxID,
		},
	});
};

export const deleteCadidateIde = async (id, data) => {
	return request({
		url: `sandbox/candidate/ide/${id}/`,
		method: "delete",
		params: data,
	});
};

export const evaluateSandbox = async (data) => {
	return request({
		url: `can/v2/marking/`,
		method: "post",
		data,
	});
};

export function getPreviewLink(sandboxID) {
	return request({
		url: `sandbox/ide/preview-link/`,
		method: "get",
		params: {
			sandboxID,
		},
	});
}

export const postIntroductorytest = (data) => {
	return request({
		url: `v2/introductoryQuestions/`,
		method: "post",
		data,
	});
};

export function addCommunicationTest(data) {
	return request({
		url: `v2/communicationQuestions/`,
		method: "post",
		data,
	});
}

export function editCommunicationTest(data) {
	return request({
		url: `v2/communicationQuestions/`,
		method: "put",
		data,
	});
}

export function deleteCommunicationTest(data) {
	return request({
		url: `v2/communicationQuestions/`,
		method: "delete",
		data,
	});
}

export function checkFileExists(data) {
	return uploadService({
		url: "/file",
		method: "post",
		data,
	});
}

// get fees
// /lis/v2/get-hire3x-fees/
export function getGatewayCharges() {
	return request({
		url: `lis/v2/get-hire3x-fees/`,
		method: "get",
	});
}
export function getTagline(testID) {
	return request({
		url: `lis/TestOrg/generate-tagline/`,
		method: "get",
		params: {
			testID,
		},
	});
}

// Transaction API
export function getOrderTransactions(data) {
	return request({
		url: `lis/order-transactions/`,
		method: "post",
		data,
	});
}

export function exportOrderTransactionsExcel(data) {
	return request({
		url: `lis/order-transactions/`,
		method: "post",
		data,
		responseType: "blob",
	});
}

export function getTransactionSummary(data) {
	return request({
		url: `lis/order-transactions/`,
		method: "get",
		data,
	});
}
